import { render } from "./Animation_fadein.vue?vue&type=template&id=64e54235"
import script from "./Animation_fadein.vue?vue&type=script&lang=js"
export * from "./Animation_fadein.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__